import { BaseMutations } from '@/store/base-mutations';
import { PaginationProps } from '@/types';
import PartnerProductsState from './state';
import { PartnerProducts } from '../types';
import { default_partner_product } from '../services';

export default class PartnerProductsMutations extends BaseMutations<PartnerProductsState> {
  UPD_FIELD({ key, value }: { key: keyof PartnerProducts.Item, value: PartnerProducts.Item[keyof PartnerProducts.Item] }) {
    this.state.new_partner_product[key] = value;
  }

  UPD_FILE(item: File) {
    this.state.new_partner_product.image_file = item;
  }

  CLEAR_FILE() {
    this.state.new_partner_product.image_file = null;
  }

  CLEAR_PARTNER_NEW_PRODUCT() {
    this.state.new_partner_product = {
      ...default_partner_product(),
    };
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof PartnerProducts.RequestFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  SET_PARTNER_PRODUCTS(products: PartnerProducts.Item[]) {
    this.state.partner_products = products;
  }

  ADD_NEW_PARTNER_PRODUCT(product: PartnerProducts.Item) {
    this.state.partner_products.unshift(product);
  }

  TOGGLE_LOADING_PARTNER_PRODUCTS(value: boolean) {
    this.state.loading = value;
  }

  UPD_PAGINATION_PRODUCTS_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.pagination[key] = value;
  }
}
